import { render, staticRenderFns } from "./OnboardingTour.vue?vue&type=template&id=6d0fb53b&scoped=true"
import script from "./OnboardingTour.vue?vue&type=script&lang=js"
export * from "./OnboardingTour.vue?vue&type=script&lang=js"
import style0 from "./OnboardingTour.vue?vue&type=style&index=0&id=6d0fb53b&prod&lang=scss&scoped=true"
import style1 from "./OnboardingTour.vue?vue&type=style&index=1&id=6d0fb53b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0fb53b",
  null
  
)

export default component.exports